// extracted by mini-css-extract-plugin
export default {"subheader":"styles_subheader__xoz-O","subheader__toolbar":"styles_subheader__toolbar__xK4VX"};